import { render, staticRenderFns } from "./NPS.vue?vue&type=template&id=e24c6a36&scoped=true"
import script from "./NPS.vue?vue&type=script&lang=js"
export * from "./NPS.vue?vue&type=script&lang=js"
import style0 from "./NPS.vue?vue&type=style&index=0&id=e24c6a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24c6a36",
  null
  
)

export default component.exports